// export const textConstants : string {
    
// }
export class textConstants {
    public static get answeringMessage(): string { return "This is a forward of call:{0} by:{1}"; };
  }